/**
 * Тип организации
 */
export enum OrganizationTypeEnum {
  KO = 'KO', // Кредитная организация
  NFO = 'NFO', // НФО
  NKO = 'NKO' // НКО
}
